jQuery(function ($) {
    $('.list_slider_cb').slick({
        autoplay: true,
        infinite: true,
        variableWidth: true,
        arrows: false,
        pauseOnFocus: false,
        pauseOnHover: false,
    });
    $('.list_slider_bg').slick({
        autoplay: true,
        infinite: true,
        variableWidth: true,
        arrows: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    variableWidth: false,
                    slidesToShow: 1
                }
            }
        ],
    });
    $('.top-posts').slick({
        autoplay: false,
        infinite: true,
        variableWidth: true,
        arrows: false,
        pauseOnFocus: false,
        pauseOnHover: false,
    });
});